import React from 'react';
import { Box, Image, MediaOverlay, Proportion } from '@wix/design-system';
import AnimatedPreviewOverlayContent from './AnimatedPreviewOverlayContent';
import CarouselStudioBranding from '../CarouselStudioBranding';
import { getTemplateGradientBackground, GRADIENT_COLORS_COUNT } from '../../utils/templateUtils';
const TemplateCardImage = _ref => {
  let {
    imageSource,
    description,
    index,
    animatedPreview,
    hovered,
    overlayContent,
    mediaContainerClassName
  } = _ref;
  const colorIndex = index % GRADIENT_COLORS_COUNT;
  const hasAnimatedPreview = animatedPreview && Boolean(animatedPreview?.url);
  const hasOverlay = Boolean(overlayContent) || hasAnimatedPreview;
  const shouldShowAnimatedPreview = !overlayContent && hasAnimatedPreview;
  const resolvedContent = shouldShowAnimatedPreview ? /*#__PURE__*/React.createElement(AnimatedPreviewOverlayContent, {
    animatedPreview: animatedPreview
  }) : overlayContent;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      height: '100%',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(MediaOverlay, {
    hoverSkin: "dark",
    hovered: hovered,
    borderRadius: "4px 4px 0 0",
    media: /*#__PURE__*/React.createElement(Box, {
      height: "100%",
      position: "relative",
      padding: "18px 18px 0px 18px",
      background: getTemplateGradientBackground(colorIndex),
      className: mediaContainerClassName ?? ''
    }, /*#__PURE__*/React.createElement(Proportion, {
      aspectRatio: 0.9
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Image, {
      src: imageSource,
      alt: description || 'template image',
      borderRadius: "3px 3px 0px 0px",
      fit: "cover",
      style: {
        display: 'block'
      }
    }))))
  }, hasOverlay && /*#__PURE__*/React.createElement(MediaOverlay.Content, {
    visible: "hover",
    placement: "middle"
  }, resolvedContent)), /*#__PURE__*/React.createElement(CarouselStudioBranding, {
    isMobileView: false
  }));
};
export default TemplateCardImage;
//# sourceMappingURL=TemplateCardImage.js.map